import {
  ClientEntity,
  CreateOperationalEntityWithTenantInput,
  OperationalEntityInput
} from "@common-core/coat-operational-hierarchy-appsync-model";
import {toCacmSource} from "./toCacmSource";
import {toOems} from "./toOems";
import {toOrganizationInformation} from "./toOrganizationInformation";

/**
 * Legacy function that creates OperationalEntityInput without tenant ID.
 * Used when the tenant feature flag is disabled.
 */
export const toOperationalEntityInput = (
  source: ClientEntity,
  transactionId?: string
): OperationalEntityInput => {
  return {
    transactionId,
    sources: [toCacmSource(source.caId)],
    organizationInformation: toOrganizationInformation(source),
    oems: source.clientNameplates ? toOems(source.clientNameplates) : []
  };
};

/**
 * New function that creates CreateOperationalEntityWithTenantInput with required tenant ID.
 * Used when the tenant feature flag is enabled.
 */
export const toOperationalEntityWithTenantInput = (
  source: ClientEntity,
  transactionId: string,
  tenantId: string
): CreateOperationalEntityWithTenantInput => {
  return {
    transactionId,
    sources: [toCacmSource(source.caId)],
    organizationInformation: toOrganizationInformation(source),
    oems: source.clientNameplates ? toOems(source.clientNameplates) : [],
    tenantId
  };
};
